type AssetListCardTitleThumbnail = {
  isUnavailable?: boolean;
  label: string;
};

/**
 * Title for a loaded asset-list card. Callers should wait until artifact rows have replaced the
 * citation placeholder (`count: 1`, no items) before calling this.
 */
export const resolveWorkspaceAgentAssetListCardTitle = ({
  count,
  thumbnails,
}: {
  count: number;
  thumbnails: readonly AssetListCardTitleThumbnail[];
}): string => {
  const firstAvailable = thumbnails.find((item) => !item.isUnavailable) ?? thumbnails[0];

  if (!firstAvailable) {
    return count === 1 ? '1 asset' : `${count} assets`;
  }

  if (count <= 1) {
    return firstAvailable.label;
  }

  const rest = count - 1;

  return `${firstAvailable.label} and ${rest} ${rest === 1 ? 'other' : 'others'}`;
};
